import { Coordinate } from "ol/coordinate";
import { createOrUpdateFromCoordinates, Extent } from "ol/extent";
import RouterUrl from "./RouterUrl";
import RouterUrlWithExtent from "./RouterUrlWithExtent";

export class Regions {
  routerUrlSources: RouterUrl[] = [
    {minLongitude: 116.5, maxLongitude: -98.5, url: `/routea/v1/mode/`, nearestUrl: `/nearesta/v1/mode/`},
    {minLongitude: -99.5, maxLongitude: -67.5, url: `/routeb/v1/mode/`, nearestUrl: `/nearestb/v1/mode/`},
    {minLongitude: -68.5, maxLongitude: 3.5, url: `/routec/v1/mode/`, nearestUrl: `/nearestc/v1/mode/`},
    {minLongitude: 2.5, maxLongitude: 24.5, url: `/routed/v1/mode/`, nearestUrl: `/nearestd/v1/mode/`},
    {minLongitude: 23.5, maxLongitude: 59.5, url: `/routee/v1/mode/`, nearestUrl: `/neareste/v1/mode/`},
    {minLongitude: 58.5, maxLongitude: 117.5, url: `/routef/v1/mode/`, nearestUrl: `/nearestf/v1/mode/`}
  ]
  routerUrls: RouterUrlWithExtent[] = this.routerUrlSources.map(r => new RouterUrlWithExtent(r))

  public async getUrl(coords: Coordinate[], baseUrl: string): Promise<string> {
    const url = this.routerUrls.find(r => coords.every(c => r.containsCoordinate(c)))
    if(url === undefined) {
      console.error('Unable to find router url: ', coords)
      throw new Error('Unable to find route URL for coordinates')
    }

    return `${baseUrl}${url.routerUrl.url}`;
  }

  public async getNearestUrl(coord: Coordinate, baseUrl: string): Promise<string> {
    const url = this.routerUrls.find(r => r.containsCoordinate(coord))
    if(url === undefined) {
      console.error('Unable to find nearest url: ', coord)
      throw new Error('Unable to find nearest URL for coordinates')
    }

    return `${baseUrl}${url.routerUrl.nearestUrl}`;
  }

  getRouterExtent(routerUrl: RouterUrl): Extent {
    const coords: Coordinate[] = [
      [routerUrl.minLongitude, 0],
      [routerUrl.minLongitude, 90],
      [routerUrl.maxLongitude, 90],
      [routerUrl.maxLongitude, 0]
    ]
    return createOrUpdateFromCoordinates(coords)
  }
}

const regions = new Regions()
export default regions;
